import React from 'react';
import Link from 'gatsby-link';
import { injectIntl } from 'react-intl';

const i18nLink = ({ intl, to, children, ...props }) => {
    if (
        /^(http|https)/gim.test(to) ||
        /.+\.(?:pdf|png|doc|docx)$/gim.test(to)
    ) {
        return (
            <a href={to} {...props} target="__blank">
                {children}
            </a>
        );
    }
    const path = `/${intl.locale}/${to}`;
    return (
        <Link to={path} {...props}>
            {children}
        </Link>
    );
};

export default injectIntl(i18nLink);



// WEBPACK FOOTER //
// ./src/components/Link.js